import { useAppSelector } from "store/hooks";
import { selectTeacherEvaluationToken } from "store/slices/token";

export const useTeacherEvaluationToken = () => useAppSelector(selectTeacherEvaluationToken);
